import { Dialog, Transition } from '@headlessui/react';
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import React, { Fragment, useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { Marker, MarkerF } from '@react-google-maps/api';
import { MapPinIcon } from '@heroicons/react/24/solid';

function MapDialog(props) {
  const textarea = "w-full h-36 text-xs bg-[#F5F5F5] rounded-lg py-2 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"

  let [isOpen, setIsOpen] = useState(false)
  let [mapApi, setMapApi] = useState(null)
  let [geoCodeAddress, setGeoCodeAddress] = useState("Geser map untuk menentukan lokasi")
  let [lat, setLat] = useState("")
  let [lng, setLng] = useState("")


  function closeModal() {
    setIsOpen(false)
    props.onAddressConfirmed(lat, lng, geoCodeAddress)
  }

  function openModal() {
    setIsOpen(true)
  }

  const AnyReactComponent = ({ text }) => (
    <div style={{
      position: 'relative', color: 'white', background: 'red',
      height: 40, width: 60, top: -20, left: -30,
    }}>
      {text}
    </div>
  );

  const defaultProps = {
    center: { lat: -6.2124928, lng: 106.8458268 },
    zoom: 18
  };

  let [marker, setMarker] = useState([{ lat: -6.2124928, lng: 106.8458268 }]);

  const onMapClick = (e) => {
    setMarker([
      {
        lat: e.lat,
        lng: e.lng
      }
    ]);
  };

  const onMapDragEnd = (map) => {
    const latlng = {
      lat: map.center.lat(),
      lng: map.center.lng()
    }
    setLat(map.center.lat())
    setLng(map.center.lng())

    new mapApi.Geocoder().geocode(
      { 'latLng': latlng },
      function (results, status) {
        if (status == mapApi.GeocoderStatus.OK) {
          if (results[1]) {

            setGeoCodeAddress(results[1].formatted_address)
          } else {
            alert('Tidak ditemukan');
          }
        } else {
          alert('Geocoder  gagal: ' + status);
        }
      }
    )


    // if (mapApi != null) {
    //   mapApi.Geocoder.
    // }
  }

  return (
    <>
      <div className=" flex items-center justify-center">
        <div onClick={() => { setIsOpen(true) }} className='flex w-full justify-start'>
          <label className="relative  cursor-pointer flex justify-start w-full text-gray-400 focus-within:text-gray-600 ">
            <MagnifyingGlassIcon className='w-6 bg-gray-300 p-1 rounded-lg absolute mt-2 left-3 text-gray-600' />
            <p type="text" value={""} className={"pl-12 flex-grow text-xs pb-4 h-fit " + textarea}  >
              {geoCodeAddress}
            </p>
          </label>
        </div>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left ml-72 align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Tentukan Alamat Lapang
                  </Dialog.Title>

                  <div className='w-96 h-64 mt-4'>
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: process.env.REACT_APP_MAP_API_KEY }}
                      defaultCenter={defaultProps.center}
                      defaultZoom={defaultProps.zoom}
                      yesIWantToUseGoogleMapApiInternals
                      onClick={onMapClick}
                      onGoogleApiLoaded={({ map, maps }) => setMapApi(maps)}
                      onDragEnd={(map) => { onMapDragEnd(map) }}
                    >
                      {
                        marker.map((item, index) => {
                          return (
                            <>
                              <MapPinIcon key={index} className='w-8 text-primaryRed' />
                            </>
                          )
                        })
                      }


                    </GoogleMapReact>
                  </div>

                  <p className='my-6 text-center w-full font-base text-sm'>{geoCodeAddress}</p>
                  <div className="mt-4 mx-auto w-fit">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Konfirmasi Alamat
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default MapDialog;